import moment from "moment";
import { getFullName } from "../../../components/util/helpers";

export const getPdfData = (patients, activeDate) => {
  const pdfDataWithFields = patients.map((patient) => {
    const monthFields = {};
    let sum = 0;
    const currentDate = moment(activeDate);
    const daysInMonth = currentDate.daysInMonth();

    for (let day = daysInMonth; day >= 1; day--) {
      const currentDate = moment(activeDate).date(day);
      const matchingEvent = patient.approved_events.find((event) =>
        moment(event.date).isSame(currentDate, "day")
      );
      const approvalInfoMap = {
        1: "V",
        2: "ב",
        3: "ח",
      };
      let value =
        approvalInfoMap[matchingEvent?.day_center_approved_info] || "";

      // Add indication for half day
      if (matchingEvent && matchingEvent.half_day) {
        value += "/2";
        // Add 0.5 for half days
        if (value) sum += 0.5;
      } else {
        // Add 1 for full days
        if (value) sum += 1;
      }

      const reversedDay = `${day}`.split("").reverse().join("");
      const dayOfWeek = currentDate.format("dd");
      const key = `${reversedDay} ${dayOfWeek}`;
      monthFields[key] = value;
    }

    const orderedObj = {
      "סך הכל": sum,
      ...monthFields,
      "שם המטופל": getFullName(patient.surename, patient.first_name),
    };

    return orderedObj;
  });
  return pdfDataWithFields;
};
